import React, { useEffect, useRef, useState } from "react";

export default function SearchBar({ value, onChange, placeholder = "Buscar…" }) {
  const [localValue, setLocalValue] = useState(value);
  const timerRef = useRef(null);

  function handleChange(newVal) {
    setLocalValue(newVal);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => onChange(newVal), 200);
  }

  function handleClear() {
    clearTimeout(timerRef.current);
    setLocalValue("");
    onChange("");
  }

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return (
    <div className="search-bar">
      <span className="search-bar__icon" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8.5" cy="8.5" r="5.5" stroke="currentColor" strokeWidth="1.6" />
          <path d="M13.5 13.5L17 17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      </span>
      <input
        type="text"
        className="search-bar__input"
        value={localValue}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        spellCheck="false"
      />
      {localValue && (
        <button
          type="button"
          className="search-bar__clear"
          onClick={handleClear}
          aria-label="Limpar busca"
        >
          ×
        </button>
      )}
    </div>
  );
}
